/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Badge_DraftInputs */

const en_us2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const pt_br2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho`)
};

const es_419_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador`)
};

const pt_pt2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho`)
};

const fr_fr2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon`)
};

const de_de2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

const it_it2_shell_badge_draft = /** @type {(inputs: Shell_Badge_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Shell_Badge_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_badge_draft = /** @type {((inputs?: Shell_Badge_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Badge_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_badge_draft(inputs)
	if (locale === "es-419") return es_419_shell_badge_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_badge_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_badge_draft(inputs)
	if (locale === "de-DE") return de_de2_shell_badge_draft(inputs)
	if (locale === "it-IT") return it_it2_shell_badge_draft(inputs)
	return en_us2_shell_badge_draft(inputs)
});
export { shell_badge_draft as "shell.badge_draft" }